module.exports = __webpack_public_path__ + "static/media/eye.f2488ed6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/eye.svg
// module id = 204
// module chunks = 0